// src/pages/TeamDetail.jsx
import { useParams, Navigate } from "react-router-dom";
import Layout from "../layouts/Layout";
import Breadcrumb from "../components/Breadcrumb";
import { teamData } from "../data/teamData";
import TeamDetailsSection from "../components/Team/TeamDetailsSection";

const TeamDetail = () => {
  const { slug } = useParams();
  const member = teamData.find((m) => m.slug === slug);

  // Nếu slug không hợp lệ thì redirect về trang team
  if (!member) {
    return (
      <Navigate
        to="/doi-ngu"
        replace
      />
    );
  }

  return (
    <Layout>
      <Breadcrumb
        title={member.name}
        parent={{ name: "Trang chủ", path: "/" }}
        parent2={{ name: "Ban cố vấn", path: "/doi-ngu" }}
      />

      <TeamDetailsSection member={member} />
    </Layout>
  );
};

export default TeamDetail;
